export const getLocalizedDate = (value?: string, locale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE) =>
  (value ? new Date(value) : new Date()).toLocaleString(locale ?? process.env.NEXT_PUBLIC_DEFAULT_LOCALE, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
